import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.find-index";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation, serchSelect } from "@/mixins/index";
import { dataSummary, dataSummary_currency, summary_currency_other } from "@/api/dataAll/dataSummary";
import { screenDataAdd, screenDataGet } from "@/api/user";
import * as echarts from "echarts";
export default {
  name: "dataSummaryScreen",
  mixins: [tabulation, serchSelect],
  data: function data() {
    return {
      searchData: {
        kind: 1,
        all_countries: 0,
        pay_channel: ''
      },
      PercentageUnit: ["CR", "PR", "NPR", "pay_account_percent", "sameday", "otherday"],
      pageData: {},
      tableData: [],
      dates: [],
      DNU_DAU: [],
      DND_DNU: [],
      screenArr: [{
        label: this.$t('dateDotDate2'),
        prop: "date",
        isfixed: true,
        classname: "font-bold",
        tabText: "2020-01-01"
      }, {
        label: this.$t('totalRevenueDotRevenue'),
        prop: "recharge_account_amount",
        tabText: "RevenueA",
        desc: this.$t('descRevNu')
      }, {
        label: this.$t('revIapDotLabel'),
        prop: "Rev-IAP",
        tabText: "内购付费收入A",
        desc: this.$t('descRevIap')
      }, {
        label: this.$t('activeAccountDotDau'),
        prop: "active_account_num",
        tabText: "活跃账号A",
        desc: this.$t('descDau')
      }, {
        label: this.$t('newAccountDotDnu'),
        prop: "new_account_num",
        tabText: "新增账号A",
        desc: this.$t('descDnu')
      }, {
        label: this.$t('newActiveRatio'),
        prop: "DNU_DAU",
        tabText: "新增活跃比A",
        desc: this.$t('descDnuDau')
      }, {
        label: this.$t('nonNewActiveAccountNum'),
        prop: "DAU_DNU",
        tabText: "非新增活跃账号数",
        desc: this.$t('descDauDnu')
      }, {
        label: this.$t('payAccountDotDpu'),
        prop: "recharge_account_num",
        tabText: "付费账号数A",
        desc: this.$t('descDpu')
      }, {
        label: this.$t('activePayRateDotPr'),
        prop: "PR",
        tabText: "活跃付费率A",
        desc: this.$t('descPr')
      }, // {
      //   label: '付费率.PUR',
      //   prop: 'pay_account_percent',
      //   tabText: '付费率'
      // },
      {
        label: this.$t('activeArpuDotLabel'),
        prop: "pay_account_arpu",
        tabText: "活跃用户人均付费A",
        desc: this.$t('descArpu')
      }, {
        label: this.$t('payArppuDotLabel'),
        prop: "pay_account_arppu",
        tabText: "付费用户人均付费A",
        desc: this.$t('descArppu')
      }, {
        label: this.$t('loginOldUserDou'),
        prop: "dou",
        tabText: "登录老用户A",
        desc: this.$t('descDou')
      }, {
        label: this.$t('oldUserPayPou'),
        prop: "pou",
        tabText: "老用户付费数A",
        desc: this.$t('descPou')
      }, {
        label: this.$t('oldUserPayRateOpr'),
        prop: "opr",
        tabText: "老用户付费率A",
        desc: this.$t('descOpr')
      }, {
        label: this.$t('loginOldUserDorpu'),
        prop: "dorpu",
        tabText: "登录老用户人均付费A",
        desc: this.$t('descDorpu')
      }, {
        label: this.$t('loginOldUserPayDorppu'),
        prop: "dorppu",
        tabText: "登录老用户付费人均A",
        desc: this.$t('descDorppu')
      }, {
        label: this.$t('newDeviceDotDnd'),
        prop: "new_device_num",
        tabText: "新增设备A",
        desc: this.$t('descDnd')
      }, {
        label: this.$t('newDeviceAccountRatio'),
        prop: "DND_DNU",
        tabText: "新增设备账号比A",
        desc: this.$t('descDndDnu')
      }, {
        label: this.$t('newAccountRevenueDotRevNu'),
        prop: "register_recharge_amount",
        tabText: "新增账号付费总额A",
        desc: this.$t('descRevNu2')
      }, {
        label: this.$t('newPayAccountDotPnu'),
        prop: "register_recharge_pnum",
        tabText: "新增付费账号数A",
        desc: this.$t('descPnu')
      }, {
        label: this.$t('newPayRateDotNpr'),
        prop: "NPR",
        tabText: "新增付费率A",
        desc: this.$t('descNpr')
      }, // {
      //   label: '登录账号',
      //   prop: 'login_account_num',
      //   tabText: '登录账号'
      // },
      {
        label: this.$t('newAccountArppuDotLabel'),
        prop: "arpnu",
        tabText: "新增账号人均付费A",
        desc: this.$t('descArpnu')
      }, {
        label: this.$t('newPayArppuDotLabel'),
        prop: "arppnu",
        tabText: "新增付费账号人均付费A",
        desc: this.$t('descArppnu')
      }, {
        label: this.$t('newDeviceRechargeAmountLabel'),
        prop: "new_device_recharge_amount",
        tabText: "新增设备付费金额",
        desc: ""
      }, {
        label: this.$t('newDeviceRechargeNumLabel'),
        prop: "new_device_recharge_num",
        tabText: "新增设备付费数",
        desc: ""
      }, {
        label: this.$t('buyVolumeCost'),
        prop: "cost",
        tabText: "买量消耗A",
        desc: this.$t('descCost')
      }, {
        label: this.$t('installDotLabel'),
        prop: "Install",
        tabText: "新增安装量A",
        desc: this.$t('descInstall')
      }, {
        label: this.$t('iAdsDotLabel'),
        prop: "I-Ads",
        tabText: "新增投放量A",
        desc: this.$t('descIAds')
      }, {
        label: this.$t('iOrganicDotLabel'),
        prop: "I-Organic",
        tabText: "I-OrganicA",
        desc: this.$t('descIOrganic')
      }, {
        label: this.$t('kFactoryDotLabel'),
        prop: "K-Factory",
        tabText: "自然量K因子A",
        desc: this.$t('descKFactory')
      }, {
        label: this.$t('crDotLabel'),
        prop: "CR",
        tabText: "安装注册转化率A",
        desc: this.$t('descCr')
      }, {
        label: this.$t('ecpiDotLabel'),
        prop: "eCPI",
        tabText: "新增安装成本A",
        desc: this.$t('descEcpi')
      }, {
        label: this.$t('ecpaDotLabel'),
        prop: "eCPA",
        tabText: "新增账号成本A",
        desc: this.$t('descEcpa')
      }, {
        label: this.$t('ecprDotLabel'),
        prop: "eCPR",
        tabText: "新增次流成本A",
        desc: this.$t('descEcpr')
      }, {
        label: this.$t('ecppDotLabel'),
        prop: "eCPP",
        tabText: "新增付费成本A",
        desc: this.$t('descEcpp')
      }, {
        label: this.$t('revIaaDotLabel'),
        prop: "Rev-IAA",
        tabText: "广告收入A",
        desc: this.$t('descRevIaa')
      }, {
        label: this.$t('darpuDotLabel'),
        prop: "DARPU",
        tabText: "活跃人均贡献A",
        desc: this.$t('descDarpu')
      }, {
        label: this.$t('ecprCountLabel'),
        prop: "eCPR_count",
        tabText: "次留用户数A",
        desc: this.$t('descEcprCount')
      }],
      defaultNotShown: ["DNU_DAU", "DND_DNU", "DAU_DNU", "arpnu", "arppnu", "K-Factory", "eCPA", "eCPR", "eCPP", "eCPR_count", "new_device_recharge_amount", "new_device_recharge_num", "dou", "pou", "opr", "dorpu", "dorppu"],
      defaultNotShownL_R_R: [],
      LTVList: [],
      acLTVList: [],
      ROIList: [],
      acROIList: [],
      RRList: [],
      acRRList: [],
      screen: [],
      sericeArr: [],
      otherArr: [],
      isShow: true,
      wxProp: [{
        label: this.$t('androidRecharge'),
        prop: "android_recharge",
        isfixed: false,
        tabText: "安卓充值"
      }, {
        label: this.$t('iosRecharge'),
        prop: "iOS_recharge",
        isfixed: false,
        tabText: "IOS充值"
      }],
      countryPro: [{
        label: this.$t('countryDotCountry'),
        prop: "country",
        isfixed: false,
        tabText: ""
      }],
      countryAllList: [{
        label: this.$t('countryDefault'),
        value: 0
      }, {
        label: this.$t('allCountries'),
        value: 1
      }],
      countryShow: false,
      cellStylekeys: ["ROI", "RR", "LTV", "acLTV", "acRR"],
      additionList: ["recharge_account_amount", "Rev-IAP", "DNU_DAU", "active_account_num", "new_account_num", "register_recharge_pnum", "DAU_DNU", "recharge_account_num", "new_device_num", "register_recharge_amount", "new_device_recharge_amount", "new_device_recharge_num", "cost", "Install", "I-Ads", "I-Organic", "Rev-IAA", "eCPR_count", "PR", "pay_account_arpu", "pay_account_arppu", "NPR", "DND_DNU", "arpnu", "arppnu", "K-Factory", "CR", "eCPI", "eCPA", "eCPR", "eCPP", "DARPU"],
      compute: [{
        // 活跃付费率  付费账号数/活跃账号
        prop: "PR",
        divisor: "recharge_account_num",
        dividend: "active_account_num"
      }, {
        // 活跃用户人均付费  内购付费收入 / 活跃账号
        prop: "pay_account_arpu",
        divisor: "Rev-IAP",
        dividend: "active_account_num"
      }, {
        // 付费用户人均付费  内购付费收入 / 内购付费账号数
        prop: "pay_account_arppu",
        divisor: "Rev-IAP",
        dividend: "recharge_account_num"
      }, {
        // 新增设备账号比  新增设备  /  新增账号 
        prop: "DND_DNU",
        divisor: "new_device_num",
        dividend: "new_account_num"
      }, {
        // 新增付费率     新增付费账号数 /  新增账号
        prop: "NPR",
        divisor: "register_recharge_pnum",
        dividend: "new_account_num"
      }, {
        // 新增付费账号人均付费     新增账号付费总额 /  新增付费账号数
        prop: "arppnu",
        divisor: "register_recharge_amount",
        dividend: "register_recharge_pnum"
      }, {
        // 新增账号人均付费   新增账号付费总额 / 新增账号
        prop: "arpnu",
        divisor: "register_recharge_amount",
        dividend: "new_account_num"
      }, {
        // 自然量K因子   新增自然量 / 新增投放量
        prop: "K-Factory",
        divisor: "I-Organic",
        dividend: "I-Ads"
      }, {
        // 安装注册转化率  新增账号 / 新增安装量
        prop: "CR",
        divisor: "new_account_num",
        dividend: "Install"
      }, {
        // 新增安装成本  买量消耗 / 新增安装量
        prop: "eCPI",
        divisor: "cost",
        dividend: "Install"
      }, {
        // 新增账号成本  买量消耗 / 新增账号数
        prop: "eCPA",
        divisor: "cost",
        dividend: "new_account_num"
      }, {
        // 新增次留成本  买量消耗 / 次留用户数
        prop: "eCPR",
        divisor: "cost",
        dividend: "eCPR_count"
      }, {
        // 新增付费成本   买量消耗 / 新增付费人数
        prop: "eCPP",
        divisor: "cost",
        dividend: "register_recharge_pnum"
      }, {
        // 活跃人均贡献   总收入 / 活跃账号
        prop: "DARPU",
        divisor: "recharge_account_amount",
        dividend: "active_account_num"
      }],
      screenData: null,
      screenDataShow: false
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return screenDataGet();

            case 2:
              _this.screenData = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // 初始化表头数据
    initscreenArr: function initscreenArr() {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        _this2.otherArr = [];
        _this2.PercentageUnit = ["CR", "PR", "NPR", "pay_account_percent", "sameday", "otherday"];

        _this2.LTVList.forEach(function (i) {
          _this2.otherArr.push({
            label: "LTV" + i,
            prop: "LTV" + i,
            tabText: "LTV" + (i == 1 ? "".concat(i, "A") : i),
            desc: i == 1 ? _this2.$t('firstDayUserAverageValue') : ""
          });
        });

        _this2.acLTVList.forEach(function (i) {
          _this2.otherArr.push({
            label: _this2.$t('activateDeviceLtvTitle') + i,
            prop: "acLTV" + i,
            tabText: "激活设备LTV" + (i == 1 ? "".concat(i, "A") : i),
            desc: i == 1 ? _this2.$t('firstDayActivateDeviceAvgValue') : ""
          });
        });

        _this2.ROIList.forEach(function (i) {
          _this2.otherArr.push({
            label: _this2.$t('roiLabel') + i,
            prop: "ROI" + i,
            tabText: "ROI" + (i == 1 ? "".concat(i, "A") : i),
            desc: i == 1 ? _this2.$t('firstDayRoi') : ""
          });
        }); // this.acROIList.forEach((i) => {
        //   this.otherArr.push({
        //     label: "激活设备ROI" + i,
        //     prop: "acROI" + i,
        //     tabText: "激活设备ROI" + (i == 1 ? `${i}A` : i),
        //     desc: i == 1 ? "首日激活设备投放回本率" : "",
        //   });
        // });


        _this2.RRList.forEach(function (i) {
          _this2.otherArr.push({
            label: _this2.$t('rrPrefix') + i,
            prop: "RR" + i,
            tabText: "RR" + (i == 2 ? "".concat(i, "A") : i),
            desc: i == 2 ? _this2.$t('nextDayAccountRetention') : ""
          });

          _this2.PercentageUnit.push("RR" + i);
        });

        _this2.acRRList.forEach(function (i) {
          _this2.otherArr.push({
            label: _this2.$t('payAccountRrLabel', {
              day: i
            }),
            prop: "acRR" + i,
            tabText: "付费账号RR" + (i == 2 ? "".concat(i, "A") : i),
            desc: i == 2 ? _this2.$t('nextDayAccountRetention') : ""
          });

          _this2.PercentageUnit.push("acRR" + i);
        });

        _this2.defaultNotShownL_R_R.forEach(function (i) {
          _this2.defaultNotShown.push("LTV" + i);

          _this2.defaultNotShown.push("acLTV" + i);

          _this2.defaultNotShown.push("ROI" + i);

          _this2.defaultNotShown.push("RR" + i);

          _this2.defaultNotShown.push("acRR" + i);
        });

        resolve();
      });
    },
    screenControls: function screenControls() {
      var _this3 = this;

      this.isShow = false;
      var list = [];
      this.screenArr.forEach(function (i) {
        if (_this3.screen.findIndex(function (t) {
          return t == i.prop;
        }) !== -1) {
          list.push(i);
        }
      });
      this.sericeArr = list;

      if (this.tableData.length) {
        setTimeout(function () {
          _this3.isShow = true;

          _this3.$nextTick(function () {
            _this3.columnDropInit();
          });
        }, 200);
        this.getechart();
      }

      screenDataAdd({
        data: JSON.stringify(list)
      });
      this.$nextTick(function () {
        _this3.setTableRight(0);
      }); // this.$store.commit("d2admin/serchSelect/setsericeArr", list);
    },
    // 重置筛选
    ResetFilter: function ResetFilter() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var newArr;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this4.loopSearch();

              case 2:
                newArr = _this4.screenArr.filter(function (item) {
                  return !_this4.defaultNotShown.some(function (ele) {
                    return ele === item.prop;
                  });
                });
                _this4.screen = newArr.map(function (i) {
                  return i.prop;
                });

                _this4.screenControls();

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    searchClickNs: function searchClickNs() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.timeInterval();

              case 2:
                reqFn = dataSummary;

                if (_this5.currencyClose && !_this5.searchData.pay_channel) {
                  reqFn = dataSummary_currency;
                } else if (_this5.searchData.pay_channel) {
                  reqFn = summary_currency_other;
                }

                _this5.reqLoading = true;
                _context3.next = 7;
                return _this5.getexchangeRate();

              case 7:
                _this5.searchClickPoints(reqFn, 1);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    searchClick: function searchClick(lists) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var qres, res, list, clist, newArr, other, summaryDataCalculate, k, DNU_DAUDay, _k2, _k3, _k4, newData, country, key, i, _key, activeAccount, newAccount, rechargeNum, registerRechargePnum, revIAP, registerRechargeAmount, dou, pou, opr, dorpu, dorppu, ds, _i, data, _loop, _key2;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                qres = JSON.parse(JSON.stringify(lists));
                res = {
                  data: {
                    data: {},
                    summary: {
                      LTV: {},
                      ROI: {},
                      acRRAvgData: {},
                      acdeLtv: {},
                      avgData: {},
                      data: {},
                      other: {}
                    }
                  }
                };
                res.data.summary = _objectSpread({}, qres[0].summary);
                /**
                 * 表头数据处理
                 */

                console.log("qres===游戏数据汇总", qres);
                _this6.LTVList = Object.keys(qres[0].summary['LTV']);
                _this6.acLTVList = Object.keys(qres[0].summary['acdeLtv']);
                _this6.ROIList = Object.keys(qres[0].summary['ROI']);
                _this6.RRList = Object.keys(qres[0].summary['avgData']);
                _this6.acRRList = Object.keys(qres[0].summary['acRRAvgData']);
                _context4.next = 11;
                return _this6.initscreenArr();

              case 11:
                if (!_this6.screenDataShow) {
                  _this6.screenDataShow = true;
                  list = _this6.screenData.data ? JSON.parse(_this6.screenData.data) : []; // 去除原动态表头与历史表头不匹配的项

                  clist = [];
                  list.forEach(function (i) {
                    // if (this.screenArr.findIndex((c) => c.prop == i.prop) > -1) {
                    //   clist.push(i);
                    // }
                    var targetItem = _this6.screenArr.find(function (c) {
                      return c.prop == i.prop;
                    });

                    if (targetItem) {
                      clist.push(targetItem); // 这里 push 的是最新语言的 label
                    }
                  });
                  _this6.sericeArr = [].concat(clist);
                  _this6.screen = (list.length ? list : _this6.screenArr).map(function (item) {
                    return item.prop;
                  });

                  if (!list.length) {
                    newArr = _this6.screen.filter(function (item) {
                      return !_this6.defaultNotShown.some(function (ele) {
                        return ele === item;
                      });
                    });
                    _this6.screen = newArr;

                    _this6.screenControls();
                  }
                } // 


                qres.map(function (i) {
                  i.summary.summaryDataCalculate = i.summary.summaryDataCalculate ? i.summary.summaryDataCalculate : i.summaryDataCalculate;
                });
                _this6.dates = [];
                other = {
                  "recharge_account_amount": 0,
                  "active_account_num": 0,
                  "new_account_num": 0,
                  "recharge_account_num": 0,
                  "pay_account_arpu": 0,
                  "pay_account_arppu": 0,
                  "new_device_num": 0,
                  "register_recharge_amount": 0,
                  "register_recharge_pnum": 0,
                  "arpnu": 0,
                  "arppnu": 0,
                  "cost": 0,
                  "Install": 0,
                  "I-Ads": 0,
                  "I-Organic": 0,
                  "K-Factory": 0,
                  "CR": 0,
                  "PR": 0,
                  "NPR": 0,
                  "Rev-IAP": 0,
                  "Rev-IAA": 0,
                  "DARPU": 0,
                  "eCPI": 0,
                  "eCPA": 0,
                  "eCPR": 0,
                  "eCPP": 0,
                  "eCPR_count": 0,
                  "android_recharge": 0,
                  "iOS_recharge": 0,
                  "new_device_recharge_num": 0,
                  "new_device_recharge_amount": 0,
                  "DNU_DAU": 0,
                  "DAU_DNU": 0,
                  "DND_DNU": 0,
                  "dou": 0,
                  "pou": 0,
                  "opr": 0,
                  "dorpu": 0,
                  "dorppu": 0
                }; // qres[0].summary.summaryDataCalculate = qres[0].summary.summaryDataCalculate ? qres[0].summary.summaryDataCalculate : qres[0].summaryDataCalculate 

                summaryDataCalculate = {
                  ltv_amount: qres[0].summary.summaryDataCalculate.ltv_amount.map(function (j) {
                    return 0;
                  }),
                  acdevice_ltv_amount: qres[0].summary.summaryDataCalculate.acdevice_ltv_amount.map(function (j) {
                    return 0;
                  }),
                  register_people_num: 0,
                  activity_devicere_num: 0,
                  activity_to_num: 0,
                  active_people_num_count: 0,
                  activity_devicere_retain_num: {},
                  retain_num: {}
                };

                for (k in qres[0].summary.summaryDataCalculate.retain_num) {
                  summaryDataCalculate.retain_num[k] = 0;
                  summaryDataCalculate.activity_devicere_retain_num[k] = 0;
                }

                DNU_DAUDay = 0;
                qres.forEach(function (i) {
                  res.data.data = _objectSpread(_objectSpread({}, res.data.data), i.data);

                  if (i.summary.other['DNU_DAU']) {
                    DNU_DAUDay = DNU_DAUDay + 1;
                  }

                  _this6.additionList.forEach(function (j) {
                    other[j] = Number(other[j]) + Number(i.summary.other[j]);
                  });

                  i.summary.summaryDataCalculate.ltv_amount.forEach(function (j, ji) {
                    summaryDataCalculate.ltv_amount[ji] = summaryDataCalculate.ltv_amount[ji] + j;
                  });
                  i.summary.summaryDataCalculate.acdevice_ltv_amount.forEach(function (j, ji) {
                    summaryDataCalculate.acdevice_ltv_amount[ji] = summaryDataCalculate.acdevice_ltv_amount[ji] + j;
                  });

                  for (var _k in i.summary.summaryDataCalculate.retain_num) {
                    summaryDataCalculate.retain_num[_k] = Number(summaryDataCalculate.retain_num[_k]) + Number(i.summary.summaryDataCalculate.retain_num[_k]);
                    summaryDataCalculate.activity_devicere_retain_num[_k] = Number(summaryDataCalculate.activity_devicere_retain_num[_k]) + Number(i.summary.summaryDataCalculate.activity_devicere_retain_num[_k]);
                  }

                  summaryDataCalculate.register_people_num = summaryDataCalculate.register_people_num + i.summary.summaryDataCalculate.register_people_num;
                  summaryDataCalculate.activity_devicere_num = summaryDataCalculate.activity_devicere_num + i.summary.summaryDataCalculate.activity_devicere_num;
                  summaryDataCalculate.active_people_num_count = summaryDataCalculate.active_people_num_count + i.summary.summaryDataCalculate.active_people_num_count;
                  summaryDataCalculate.activity_to_num = summaryDataCalculate.activity_to_num + i.summary.summaryDataCalculate.activity_to_num;
                });
                other['DNU_DAU'] = DNU_DAUDay == 0 ? '0.000' : other['DNU_DAU'] / DNU_DAUDay; // LTV

                for (_k2 in res.data.summary.LTV) {
                  res.data.summary.LTV[_k2] = summaryDataCalculate.register_people_num == 0 ? 0 : summaryDataCalculate.ltv_amount[Number(_k2) - 1] / summaryDataCalculate.register_people_num;
                  res.data.summary.acdeLtv[_k2] = summaryDataCalculate.activity_to_num == 0 ? 0 : summaryDataCalculate.acdevice_ltv_amount[Number(_k2) - 1] / summaryDataCalculate.activity_to_num;
                } // ROI


                for (_k3 in res.data.summary.ROI) {
                  res.data.summary.ROI[_k3] = other.cost == 0 ? 0 : summaryDataCalculate.ltv_amount[Number(_k3) - 1] / other.cost;
                } // 留存


                for (_k4 in res.data.summary.avgData) {
                  res.data.summary.avgData[_k4] = ((summaryDataCalculate.register_people_num == 0 ? 0 : summaryDataCalculate.retain_num[_k4] / summaryDataCalculate.register_people_num) * 100).toFixed(2) + '%';
                  res.data.summary.acRRAvgData[_k4] = ((summaryDataCalculate.activity_devicere_num == 0 ? 0 : summaryDataCalculate.activity_devicere_retain_num[_k4] / summaryDataCalculate.activity_devicere_num) * 100).toFixed(2) + '%';
                }

                res.data.summary.other = _objectSpread({}, other);
                _this6.isShow = true;
                _this6.tableData = [];
                newData = {};

                if (!(JSON.stringify(res.data.data) == "[]")) {
                  _context4.next = 29;
                  break;
                }

                return _context4.abrupt("return");

              case 29:
                // 改为
                res.data.summary.data = res.data.summary.avgData;
                res.data.summary.acRR = res.data.summary.acRRAvgData;
                country = _this6.searchData.country.length ? _this6.searchData.country : [];

                if (_this6.searchData.all_countries == 1) {
                  country = res.data.countryList; // for(let i in res.data.data){
                  //   for(let k in res.data.data[i]['LTV']){
                  //     country.push(k)
                  //   }
                  //   break
                  // }
                } // 数据重组


                if (_this6.searchData.country.length || _this6.searchData.all_countries == 1) {
                  if (country.length) {
                    country.forEach(function (item) {
                      for (var key in res.data.data) {
                        for (var jkey in res.data.data[key]) {
                          if (res.data.data[key][jkey][item]) {
                            newData[key + "/" + item] = !newData[key + "/" + item] ? {} : newData[key + "/" + item];
                            newData[key + "/" + item][jkey] = jkey !== "other" ? _objectSpread({}, res.data.data[key][jkey][item]) : _objectSpread(_objectSpread({}, res.data.data[key][jkey][item]), {}, {
                              country: item
                            });
                          }
                        }
                      }
                    });
                    newData[_this6.$t('total')] = res.data.summary;
                  }
                } else {
                  newData = res.data.data;
                  newData[_this6.$t('total')] = res.data.summary;
                }

                console.log("newData===", newData);
                _this6.countryShow = _this6.searchData.all_countries == 1 || _this6.searchData.country.length ? true : false;
                _this6.pageData = _objectSpread({}, newData); // 初始化折线图数据

                _context4.t0 = regeneratorRuntime.keys(newData);

              case 38:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 56;
                  break;
                }

                key = _context4.t1.value;

                for (i in newData[key].other) {
                  _this6[i] = [];
                }

                _this6.LTVList.forEach(function (i) {
                  _this6["LTV" + i] = [];
                });

                _this6.acLTVList.forEach(function (i) {
                  _this6["acLTV" + i] = [];
                });

                _this6.ROIList.forEach(function (i) {
                  _this6["ROI" + i] = [];
                }); // this.acROIList.forEach((i) => {
                //   this["acROI" + i] = [];
                // });


                _this6.RRList.forEach(function (i) {
                  _this6["RR" + i] = [];
                });

                _this6.acRRList.forEach(function (i) {
                  _this6["acRR" + i] = [];
                });

                _this6["DNU_DAU"] = [];
                _this6["DND_DNU"] = [];
                _this6["dou"] = [];
                _this6["pou"] = [];
                _this6["opr"] = [];
                _this6["dorpu"] = [];
                _this6["dorppu"] = [];
                return _context4.abrupt("break", 56);

              case 56:
                // 数据赋值
                for (_key in newData) {
                  _this6.dates.push(_key);

                  if (_key == _this6.$t('total')) {
                    (function () {
                      // 获取天数
                      var daysCount = Object.keys(newData).filter(function (k) {
                        return k !== _this6.$t('total');
                      }).length;
                      var fields = ['PR', 'pay_account_arpu', 'pay_account_arppu', 'NPR', 'DND_DNU', 'arpnu', 'arppnu', 'K-Factory', 'CR', 'eCPI', 'eCPA', 'eCPR', 'eCPP', 'DARPU'];
                      var newDataOther = newData[_key].other; // 计算 PR、DARPU、DARPPU 的平均值

                      if (daysCount > 0) {
                        fields.forEach(function (field) {
                          if (newDataOther[field]) {
                            newDataOther[field] = newDataOther[field] / daysCount;
                          }
                        });
                      }
                    })();
                  } // 获取基础数据


                  activeAccount = Number(newData[_key].other.active_account_num) || 0;
                  newAccount = Number(newData[_key].other.new_account_num) || 0;
                  rechargeNum = Number(newData[_key].other.recharge_account_num) || 0;
                  registerRechargePnum = Number(newData[_key].other.register_recharge_pnum) || 0;
                  revIAP = Number(newData[_key].other["Rev-IAP"]) || 0;
                  registerRechargeAmount = Number(newData[_key].other.register_recharge_amount) || 0;
                  dou = Math.max(0, activeAccount - newAccount); // 计算 pou = 付费账号数 - 新增付费账号数

                  pou = rechargeNum - registerRechargePnum; // 计算 opr = pou / dou (转换为百分比)

                  opr = 0;

                  if (dou > 0) {
                    opr = pou / dou * 100;
                  } // 计算 dorpu = (内购付费收入 - 新增账号付费总额) / dou


                  dorpu = 0;

                  if (dou > 0) {
                    dorpu = (revIAP - registerRechargeAmount) / dou;
                  } // 计算 dorppu = (内购付费收入 - 新增账号付费总额) / pou


                  dorppu = 0;

                  if (pou > 0) {
                    dorppu = (revIAP - registerRechargeAmount) / pou;
                  }

                  newData[_key].other = _objectSpread(_objectSpread({}, newData[_key].other), {}, {
                    dou: dou,
                    pou: pou,
                    opr: opr.toFixed(2) + '%',
                    dorpu: _this6.$utils.conversion(dorpu).toFixed(2),
                    dorppu: _this6.$utils.conversion(dorppu).toFixed(2)
                  });
                  newData[_key].other.exchange = _this6.isyjfmvnd() ? (Number(newData[_key].other.recharge_account_amount) * _this6.exchangeRate).toFixed(2) : _this6.$utils.conversion(Number(newData[_key].other.recharge_account_amount) * _this6.exchangeRate).toFixed(2);
                  newData[_key].other.recharge_account_amount = _this6.isyjfmvnd() ? newData[_key].other.recharge_account_amount : _this6.$utils.conversion(newData[_key].other.recharge_account_amount).toFixed(2);
                  newData[_key].other.pay_account_arpu = _this6.$utils.conversion(newData[_key].other.pay_account_arpu).toFixed(2);
                  newData[_key].other.pay_account_arppu = _this6.$utils.conversion(newData[_key].other.pay_account_arppu).toFixed(2);
                  newData[_key].other.register_recharge_amount = _this6.isyjfmvnd() ? newData[_key].other.register_recharge_amount : _this6.$utils.conversion(newData[_key].other.register_recharge_amount).toFixed(2);
                  newData[_key].other["Rev-IAA"] = _this6.$utils.conversion(newData[_key].other["Rev-IAA"]).toFixed(2);
                  newData[_key].other["Rev-IAP"] = _this6.isyjfmvnd() ? newData[_key].other["Rev-IAP"] : _this6.$utils.conversion(newData[_key].other["Rev-IAP"]).toFixed(2);
                  newData[_key].other["DARPU"] = _this6.$utils.conversion(newData[_key].other["DARPU"]).toFixed(2);
                  newData[_key].other["eCPI"] = _this6.$utils.conversion(newData[_key].other["eCPI"]).toFixed(2);
                  newData[_key].other["eCPA"] = _this6.$utils.conversion(newData[_key].other["eCPA"]).toFixed(2);
                  newData[_key].other["eCPR"] = _this6.$utils.conversion(newData[_key].other["eCPR"]).toFixed(2);
                  newData[_key].other["eCPP"] = _this6.$utils.conversion(newData[_key].other["eCPP"]).toFixed(2);
                  newData[_key].other["cost"] = _this6.$utils.conversion(newData[_key].other["cost"]).toFixed(2);
                  newData[_key].other["new_device_recharge_amount"] = _this6.isyjfmvnd() ? newData[_key].other["new_device_recharge_amount"] : _this6.$utils.conversion(newData[_key].other["new_device_recharge_amount"]).toFixed(2); // newData[key].other.pay_account_percent = ((newData[key].other.pay_account_percent - 0) * 100).toFixed(2);

                  newData[_key].other.arpnu = _this6.$utils.conversion(newData[_key].other.arpnu).toFixed(3);
                  newData[_key].other.arppnu = _this6.$utils.conversion(newData[_key].other.arppnu).toFixed(3); // newData[key].other.sameday = this.zhuan(newData[key].other.sameday,1);
                  // newData[key].other.otherday = this.zhuan(newData[key].other.otherday,2);

                  ds = _this6.compute.find(function (i) {
                    return i.prop == 'CR';
                  });
                  newData[_key].other[ds.prop] = newData[_key].other[ds.dividend] == 0 ? 0 : newData[_key].other[ds.divisor] / newData[_key].other[ds.dividend]; // let n = (newData[key].other.CR * 100).toFixed(3)
                  // newData[key].other.CR = n == '0.000' ? 0.000 : n.slice(0, n.length - 1);

                  newData[_key].other.CR = (newData[_key].other.CR * 100).toFixed(2);
                  newData[_key].other.PR = (newData[_key].other.PR * 100).toFixed(2);
                  newData[_key].other.NPR = (newData[_key].other.NPR * 100).toFixed(2);
                  newData[_key].other['K-Factory'] = Number(newData[_key].other['K-Factory']).toFixed(3);
                  newData[_key].other['DNU_DAU'] = Number(newData[_key].other['DNU_DAU']).toFixed(3);
                  newData[_key].other['DND_DNU'] = Number(newData[_key].other['DND_DNU']).toFixed(3);

                  if (_this6.searchData.channel == "wxminigame") {
                    newData[_key].other.android_recharge = (newData[_key].other.android_recharge / 100).toFixed(2);
                    newData[_key].other.iOS_recharge = (newData[_key].other.iOS_recharge / 100).toFixed(2);
                  }

                  for (_i in newData[_key].other) {
                    _this6[_i] && _this6[_i].push(newData[_key].other[_i]);
                  }
                }

                data = JSON.parse(JSON.stringify(_this6.pageData));
                console.log("=========data", data);

                _loop = function _loop(_key2) {
                  var arr = {};

                  _this6.screenArr.forEach(function (item) {
                    arr[item.prop] = data[_key2].other[item.prop] || 0;
                  });

                  if (_this6.searchData.channel == "wxminigame") {
                    arr["android_recharge"] = data[_key2].other["android_recharge"];
                    arr["iOS_recharge"] = data[_key2].other["iOS_recharge"];
                  }

                  var defaultDatacurrency = _this6.defaultData().currency_info;

                  if (defaultDatacurrency == "VND") {
                    arr["exchange"] = data[_key2].other["exchange"];
                  }

                  if (_this6.countryShow) {
                    arr["country"] = data[_key2].other["country"];
                  } // LTV


                  var ltvData = {};

                  for (var li in data[_key2].LTV) {
                    var num = data[_key2].LTV[li] !== "/" ? _this6.$utils.conversion(data[_key2].LTV[li]).toFixed(3) : "0.000"; // let num = this.$utils.conversion('4.5').toFixed(2)

                    ltvData["LTV" + li] = num;

                    _this6["LTV" + li].push(num);
                  } // 激活设备LTV


                  var acltvData = {};

                  for (var _li in data[_key2].acdeLtv) {
                    var _num = data[_key2].acdeLtv[_li] !== "/" ? _this6.$utils.conversion(data[_key2].acdeLtv[_li]).toFixed(3) : "0.000"; // let num = this.$utils.conversion('4.5').toFixed(2)


                    acltvData["acLTV" + _li] = _num;

                    _this6["acLTV" + _li].push(_num);
                  } // ROI


                  var roiData = {};

                  for (var _li2 in data[_key2].ROI) {
                    roiData["ROI" + _li2] = Number(data[_key2].ROI[_li2]).toFixed(3);

                    _this6["ROI" + _li2].push(Number(data[_key2].ROI[_li2]).toFixed(3));
                  } // 激活设备ROI
                  // let acroiData = {};
                  // for (let li in data[key].ROI) {
                  //   acroiData["ROI" + li] = Number(data[key].ROI[li]).toFixed(3);
                  //   this["ROI" + li].push(Number(data[key].ROI[li]).toFixed(3));
                  // }
                  // RR


                  var rrData = {};

                  var _loop2 = function _loop2(_li3) {
                    var nums = Number(_li3);

                    if (_this6.RRList.findIndex(function (i) {
                      return i == nums;
                    }) > -1) {
                      var _num2 = data[_key2].data[_li3] == "/" ? 0 : _this6.zhuan(data[_key2].data[_li3], 3);

                      rrData["RR" + nums] = _num2;

                      _this6["RR" + nums].push(_num2);
                    }
                  };

                  for (var _li3 in data[_key2].data) {
                    _loop2(_li3);
                  } // acRR


                  var acrrData = {};

                  var _loop3 = function _loop3(_li4) {
                    var nums = Number(_li4);

                    if (_this6.acRRList.findIndex(function (i) {
                      return i == nums;
                    }) > -1) {
                      var _num3 = data[_key2].acRR[_li4] == "/" ? 0 : _this6.zhuan(data[_key2].acRR[_li4], 4);

                      acrrData["acRR" + nums] = _num3;

                      _this6["acRR" + nums].push(_num3);
                    }
                  };

                  for (var _li4 in data[_key2].acRR) {
                    _loop3(_li4);
                  }

                  _this6.tableData.push(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, arr), {}, {
                    // 确保新字段也被放入 tableData 数组中
                    dou: data[_key2].other.dou,
                    pou: data[_key2].other.pou,
                    opr: data[_key2].other.opr,
                    dorpu: data[_key2].other.dorpu,
                    dorppu: data[_key2].other.dorppu
                  }, ltvData), roiData), rrData), acrrData), acltvData), {}, {
                    date: _key2
                  }));
                };

                for (_key2 in data) {
                  _loop(_key2);
                }

                _this6.tableData.reverse();

                _this6.tableData.map(function (item) {
                  item.date = item.date.split("/")[0];
                  item.timeStamp = _this6.$times.timeStamp(item.date) || 999999999999999;
                });

                _this6.tableData.sort(function (a, b) {
                  return b.timeStamp < a.timeStamp ? 1 : -1;
                });

                console.log("this.tableData", _this6.tableData); // this.sericeArr = this.sericeArr.length ? this.sericeArr : this.screenArr;
                // if (this.searchData.channel == 'wxminigame' ) {
                //   wxProp.unshift(1, 0)
                //   Array.prototype.splice.apply(this.sericeArr, wxProp);
                // }

                _this6.$nextTick(function () {
                  _this6.columnDropInit();

                  _this6.getTableRight();

                  _this6.getechart();
                });

              case 66:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    zhuan: function zhuan(data, t) {
      // let n = []
      // list.forEach((item) => {
      //   n.push(item.length > 0 ? Number(item.substr(0, item.length - 1)) : 0)
      // })
      var d = 0;

      if (data) {
        d = Number(data.substr(0, data.length - 1));
      }

      return d;
    },
    getechart: function getechart() {
      var _this7 = this;

      var chartDom = document.getElementById("dataSummaryScreenEchart");
      var myChart = echarts.init(chartDom);
      var date = JSON.parse(JSON.stringify(this.dates)).splice(0, this.dates.length - 1);
      var newDate = [];
      date.forEach(function (item, index) {
        var strL = item.split("/");
        newDate[index] = {
          date: strL[0],
          timeStamp: _this7.$times.timeStamp(strL[0]),
          country: strL[1]
        };
      });
      newDate.reverse();
      newDate.sort(function (a, b) {
        return b.timeStamp < a.timeStamp ? 1 : -1;
      });
      var newDates = newDate.map(function (i) {
        return i.country ? i.date + "/" + i.country : i.date;
      });
      var newSericeArr = JSON.parse(JSON.stringify([].concat(_toConsumableArray(this.sericeArr), _toConsumableArray(this.otherArr))));
      var wxProp = JSON.parse(JSON.stringify(this.wxProp));

      if (this.searchData.channel == "wxminigame") {
        wxProp.unshift(1, 0);
        Array.prototype.splice.apply(newSericeArr, wxProp);
      }

      var option;
      var legendArr = [];
      var sericeArr = [];
      newSericeArr.forEach(function (item) {
        if (item.prop !== "date") {
          var label = item.label.split(".")[0];
          legendArr.push(label);
          sericeArr.push({
            name: label,
            type: "line",
            data: JSON.parse(JSON.stringify(_this7[item.prop])).splice(0, _this7[item.prop].length - 1),
            smooth: true
          });
        }
      });
      option = {
        title: {
          text: this.$t('dataSummary')
        },
        animationDuration: 3000,
        tooltip: {
          trigger: "axis",
          confine: true,
          formatter: function formatter(params) {
            var astr = "";
            astr += "".concat(params[0].axisValue, "<br/>");
            params.forEach(function (ele, index) {
              astr += "<div style=\"display: block;height:20px;".concat(index % 3 === 0 ? "width: 33%;" : "width: 33%;", "float:left;\">\n                        <i style=\"width: 10px;height: 10px;display: inline-block;background: ").concat(ele.color, ";border-radius: 10px;\"></i>\n                        <span>").concat(ele.seriesName, ": ").concat(ele.data, "</span>\n                        </div>");
            });
            var b = '<div style="width: 640px;">' + astr + "<div>";
            return b;
          }
        },
        legend: {
          data: legendArr,
          width: "100%",
          top: "4%",
          icon: "circle",
          itemHeight: 12,
          itemWidth: 15,
          inactiveColor: "#666666",
          formatter: ["{a|{name}}"].join("\n"),
          textStyle: {
            fontSize: 12,
            lineHeight: 12,
            rich: {
              a: {
                width: 120,
                verticalAlign: "middle"
              }
            },
            padding: [0, 0, -2, -4] //[上、右、下、左]

          }
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          top: "26%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: newDates
        },
        yAxis: {
          type: "value"
        },
        series: sericeArr
      };
      chartDom && myChart.setOption(option, true);
    },
    exportdata: function exportdata() {
      var _this8 = this;

      var d = JSON.parse(JSON.stringify(this.tableData));
      var newSericeArr = JSON.parse(JSON.stringify([].concat(_toConsumableArray(this.sericeArr), _toConsumableArray(this.otherArr))));
      var wxProp = JSON.parse(JSON.stringify(this.wxProp));
      var exchangeUSD = JSON.parse(JSON.stringify(this.exchangeUSD));
      var exchangeVND = JSON.parse(JSON.stringify(this.exchangeVND));

      if (this.searchData.channel == "wxminigame") {
        wxProp.unshift(1, 0);
        Array.prototype.splice.apply(newSericeArr, wxProp);
      }

      console.log(newSericeArr);

      if (this.queryCurrency == "USD") {// exchangeUSD.unshift(1, 0);
        // Array.prototype.splice.apply(newSericeArr, exchangeUSD);
      }

      if (this.queryCurrency == "VND") {
        exchangeVND.unshift(1, 0);
        Array.prototype.splice.apply(newSericeArr, exchangeVND);
      }

      var columns = _toConsumableArray(newSericeArr);

      if (this.countryShow) {
        columns.splice(1, 0, {
          label: this.$t('countryLabel'),
          prop: "country"
        });
      }

      d.map(function (item) {
        _this8.PercentageUnit.forEach(function (i) {
          item[i] = item[i] + "%";
        });
      });
      var data = d;
      this.$export.excel({
        columns: columns,
        data: data,
        title: this.$route.meta.title
      });
    }
  }
};